import { useEffect, useState } from "react";
import * as skillService from "../services/skillService";

// The skills a vendor's screens offer, shared by every screen in the session and
// fetched once per page load (the useHrAccess pattern). A failed request is not
// remembered, so the next screen to mount tries again; meanwhile nothing offers a
// choice, which is the safe default.
let cached = null;
let inflight = null;

const fetchOnce = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = skillService
      .getSkills()
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) cached = res.data;
        return cached || [];
      })
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

// Test hook: forget what was fetched.
export const resetSkillsCache = () => {
  cached = null;
  inflight = null;
};

// `enabled` false (for example a Super Admin, who has no vendor) never calls the API.
export default function useSkills(enabled = true) {
  const [skills, setSkills] = useState(cached || []);
  const [loaded, setLoaded] = useState(!!cached || !enabled);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    fetchOnce().then((list) => {
      if (cancelled) return;
      setSkills(list);
      setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    skills,
    loaded,
    offersChoice: skillService.offersChoice(skills),
    labelFor: (key) => skillService.skillLabel(skills, key),
  };
}
